export const getProjectExpirationText = (expiresAt: string | null | undefined) => {
  if (expiresAt == null) {
    console.log('Missing project expiration date value');
    return 'unknown remaining time';
  }
  const future = new Date(expiresAt);
  const now = new Date();
  const remaining = future.getTime() - now.getTime();

  const days = Math.floor(remaining / 86400000);
  if (days > 0) return `${days} day${days > 1 && 's'}`;

  const hours = Math.floor(remaining / 3600000);
  if (hours > 0) return `${hours} hour${hours > 1 && 's'}`;

  const mins = Math.floor(remaining / 60000);
  if (mins > 0) return `${mins} minute${mins > 1 && 's'}`;

  return 'less than a minute';
};

export const validateBillingExpiration = (expiration: string | null | undefined) => {
  if (expiration == null) {
    console.log('Missing card expiration date value');
    return false;
  }
  const [month, year] = expiration.split('/');
  const date = new Date(+year, +month);
  const now = new Date();
  if (date.getTime() < now.getTime()) return false;
  return true;
};
